import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ResponseList } from 'models';
import { Employee } from 'models/user/Employee';

export type UseEmployeeInformationByUserIdProps = {
    enabled?: boolean;
    sid?: string;
    platformId?: string;
    userId?: string;
};

export function useEmployeeInformationByUserId(props: UseEmployeeInformationByUserIdProps) {
    const { enabled, sid, platformId, userId } = props;

    return useQuery({
        enabled,
        queryKey: ['employee-information', { sid: sid, platform_id: platformId, user_id: userId }],
        queryFn: ({ signal }) =>
            axios.get<ResponseList<Employee>>('/v1/f1/employee', {
                signal,
                params: {
                    sid,
                    platform_id: platformId,
                    user_id: userId
                }
            }),
        select: response =>
            response.data.result_list?.length > 0 ? response.data.result_list[0] : undefined,
        retry: 1
    });
}
